import React, { Component } from "react";
import MainLayout from '../../mainLayout';

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//Service import 
import service from '../../services'

//import AWS from "aws-sdk";
import AWS from "aws-sdk"; 

// Images import
import selectArrow from "../../assets/images/select-arrow.svg";
import plusIcon from "../../assets/images/plusIcon.svg";
import background from "../../assets/images/background.jpg";
import Loader from "../loader";
import CheckBox from "../CheckBox";

//moment import
import moment from "moment-timezone";

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import TextEditor from "../TextEditor";
import ErrorPopUp from "../errorPopUp";
import commonImage from "../../commonImage";

let sub;
const mapStateToProps = state => ({
    getPartnerDetails : state.getPartnerDetails,
    getLoginRole : state.getLoginRole 
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

class profilePartnerView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email:'',
            contactFullName:'',
            lastName:'',
            getPerticularPartner:'',
            // instituteAssociate:false,
            file: null,
            id:'',
            selectedDropdown:'',
            imagePreloader:false,
            imagePreloader1:false,
            loaderFlag:false,
            partnerPageDescription:EditorState.createEmpty(),
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                  message: 'Please use a valid name of the :attribute',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,/^([-a-zA-Z . _']*)$/i) && params.indexOf(val) === -1
                  },
                  required: true  // optional
                },
                companyName: {  // name the rule
                  message: 'Please use a valid name of the :attribute',
                  rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val,/^([-a-zA-Z0-9 . : , _ + @ & | ( )']*)$/i ) && params.indexOf(val) === -1
                  },
                  required: false  // optional
            }
              } });
        this.apiserve = new service();
    }

    componentDidMount = async() => {
        // this.apiserve.connect();     
        this.getPartner();
        this.getPartnerID();
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "getUser":
                this.setState({
                    getPerticularPartner:response.data
                  },()=>{

                    const blocksFromHtml = htmlToDraft(response.data.partnerPageDescription ? response.data.partnerPageDescription : "");
                    const { contentBlocks, entityMap } = blocksFromHtml;
                    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                    const editorState = EditorState.createWithContent(contentState);
                    this.setState({
                        contactFullName:response.data.contactFullName,
                        partnerName:response.data.partnerName,
                        partnerVenueName:response.data.partnerVenueName,
                        image:response.data.image,
                        email:response.data.email,
                        partnerLogo:response.data.partnerLogo,
                        image:response.data.image,
                        id:response.data._id,
                        // instituteAssociate: response.data.instituteAssociate,
                        editorState:editorState,
                      })
                  })
                break;

                case "FestivalVillage|Partner|getPartnerById":
                      this.setState({
                          updateDate: response.data.updatedAt,
                          updatedBy:response.data.addedBy
                        })
                  break;
                case "FestivalVillage|Partner|edit":
                    if(response.error){
                        this.apiserve.error(response.data.error ?  response.data.error : response.data)
                    }else{
                        this.getPartner()
                        this.getPartnerID();
                        this.apiserve.success('Partner user updated successful.')
                    }
                break;
            }
        })
    }

    componentWillUnmount = () => {
    sub.unsubscribe();
  }

    getPartner = () => {
        const {getLoginRole} = this.props
        this.apiserve.sendevent("getUser", {
           id:getLoginRole.user._id
        });
    }

    getPartnerID = () => {
      const {getLoginRole} = this.props
      this.apiserve.sendevent("FestivalVillage|Partner|getPartnerById", {
         id:getLoginRole.user._id
      });
  }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onInputChangeDropDown = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            selectedDropdown: e.target.value
        });
    }

    submitFn =async (e) => {
        const {getPartnerDetails} = this.props
        e.preventDefault();
        if (this.validator.allValid()) {

            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const  markup= draftToHtml(name);

          let data= {
            contactFullName: this.state.contactFullName,
            partnerPageDescription:markup,
            email: this.state.email,
            partnerName: this.state.partnerName,
            partnerVenueName:this.state.partnerVenueName,
            image:this.state.image,
            partnerLogo:this.state.partnerLogo,
            id:this.state.id,
            image:this.state.image,
            // instituteAssociate:this.state.instituteAssociate
          }
    this.apiserve.sendevent("FestivalVillage|Partner|edit", data); 
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    clearFn = () => {
        this.setState({
            contactFullName:"",
            partnerName:"",
            partnerVenueName:"",
            image:"",
            partnerLogo:"",
            instituteAssociate:false,
            partnerPageDescription:EditorState.createEmpty(),
        });
    };

    onChangeFile(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          this.setState({
            file: file,
            // partnerLogo: reader.result
          }, () => {
            const fileList = Math.round((file && file.size / 1024));
            if (fileList >= 2048) {
              this.setState({
                errorPopup: true,
                errorMsg: 'Please upload a file smaller than 2 MB'
              })
              return false;
            }
            if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                setTimeout(() => {
                    this.imageUpload(file,event.target.result);
                  },0)
            } else {
              this.setState({
                errorPopup: true,
                errorMsg: 'Please upload a file for PNG,JPG or JPEG'
              })
            }
          })
        }
    }

    imageUpload = (file, img) => {
        this.setState({imagePreloader:true})

        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            this.setState({
              partnerLogo: value,          
              imagePreloader:false
            });
          });
    };

    onChangeFileVenueImage(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          this.setState({
            file: file,
            // partnerLogo: reader.result
          }, () => {
            const fileList = Math.round((file && file.size / 1024));
            if (fileList >= 2048) {
              this.setState({
                errorPopup: true,
                errorMsg: 'Please upload a file smaller than 2 MB'
              })
              return false;
            }
            if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                setTimeout(() => {
                    this.imageUploadVenue(file,event.target.result);
                  },0)
            } else {
              this.setState({
                errorPopup: true,
                errorMsg: 'Please upload a file for PNG,JPG or JPEG'
              })
            }
          })
        }
    }

    imageUploadVenue = (file, img) => {
        this.setState({imagePreloader1:true})

        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            this.setState({
              image: value,          
              imagePreloader1:false
            });
          });
    };

    handleUncheck = (e) => {
        const { name, value, checked } = e.target;
        this.setState({
            [name]:checked
        })
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState
        });
    };

    errorMsgPopup = () => {
        this.setState({
          errorPopup: false
        })
      }

    render() {
        const {getPerticularPartner} = this.state;
        const {getLoginRole} = this.props;
        return (
            <React.Fragment>
                    <div className={`right_side_wrapper partnerView_wrapper ${getLoginRole.user.role  === "partner" ? "partner_view_wrapper" : ""}`}>
                        <div className="dashboard_header profile_header">
                            <div className="searchBlock">
                                <span>{getPerticularPartner && getPerticularPartner.partnerName}</span>
                            </div>
                        </div>
                        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                          <p></p>
                          <p className="update_date">
                            Last Update: {moment(this.state.updateDate).tz("US/Mountain").format('h')}:{moment(this.state.updateDate).tz("US/Mountain").format('mm')} {moment(this.state.updateDate).tz("US/Mountain").format('A')}{' '}
                          MT- {moment.tz(this.state.updateDate, "US/Mountain").format('MM/DD/YYYY')}{' '}Last Updated By: {this.state.updatedBy && this.state.updatedBy.fname} {this.state.updatedBy && this.state.updatedBy.lname}

                          </p>
                        </div>
                        <div className="profilePartnerView_block">
                            <form>
                                <div className="details">                               
                                    <div className="partnerLogo">
                                        <label>Partner Logo</label>
                                        <div className='image_pre_loader'>
                                        <input id="myInput"
                                            type="file"
                                            ref={(ref) => this.upload = ref}
                                            style={{display: 'none'}}
                                            onChange={this.onChangeFile.bind(this)}
                                            accept=".png, .jpg, .jpeg"
                                            />
                                            {this.state.imagePreloader ?
                                                <Loader/>
                                            :
                                            <img src={this.state.partnerLogo ?
                                                 this.apiserve.imageUrl + this.state.partnerLogo 
                                            : background} />
                                            }
                                            <a onClick={()=>{this.upload.click()}}><img src={plusIcon} /></a>
                                        </div>
                                    </div>   
                                    <div className="partnerLogo">
                                        <label>Partner Venue Image</label>
                                        <div className='image_pre_loader'>
                                        <input id="myInput"
                                            type="file"
                                            ref={(ref) => this.upload1 = ref}
                                            style={{display: 'none'}}
                                            onChange={this.onChangeFileVenueImage.bind(this)}
                                            accept=".png, .jpg, .jpeg"
                                            />
                                            {this.state.imagePreloader1 ?
                                                <Loader/>
                                            :
                                            <img src={this.state.image ?
                                                 this.apiserve.imageUrl + this.state.image 
                                            : background} />
                                            }
                                            <a onClick={()=>{this.upload1.click()}}><img src={plusIcon} /></a>
                                        </div>
                                    </div>     
                                    <div className="form_group">
                                        <label>Partner Venue Name</label>
                                        <div className="form_group_input"> 
                                            <input type="text" name="partnerVenueName" id="partnerVenueName"
                                                value={this.state.partnerVenueName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('partner venue name', this.state.partnerVenueName, 'required')}</span>
                                        </div>   
                                    </div>                         
                                    <div className="form_group">
                                        <label>Partner Name</label>
                                        <div className="form_group_input"> 
                                            <input type="text" name="partnerName" id="partnerName"
                                                value={this.state.partnerName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('partner name', this.state.partnerName, 'required')}</span>
                                        </div>   
                                    </div>         
                                    <div className="form_group">
                                        <label>Contact Email</label>
                                        
                                        <div className="form_group_input">
                                            <input
                                                type="email"
                                                disabled
                                                name="email"
                                                id="email"
                                                maxLength={255}
                                                value={this.state.email}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>       
                                    <div className="form_group">
                                        <label>Contact Full Name</label>
                                        
                                        <div className="form_group_input">
                                            <input 
                                                type="text"
                                                name="contactFullName"
                                                id="contactFullName"
                                                value={this.state.contactFullName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('contactFullName', this.state.contactFullName, 'required')}</span>
                                        </div>       
                                    </div>
                                    <div className="form_group">
                                        <label>Partner Page Description</label>
                                        <div className="editor_400">

                                        <TextEditor
                                            name="editorState"
                                            editorState={this.state.editorState}
                                            value={this.state.editorState}
                                            onEditorStateChange={(e) =>
                                            this.onEditorStateChange(e)}
                                        />
                                        </div>       
                                    </div>
                                    {/* <div className="form_group">
                                            <label>Institute Associate</label>
                                            <div className="form_group_input">
                                           
                                            <CheckBox name='instituteAssociate' checked={this.state.instituteAssociate} value={this.state.instituteAssociate} onChange={this.handleUncheck} type="checkbox" id="instituteAssociate"/>
                                            </div>
                                      </div> */}
                                  </div>
                                <div className="btn_wrapper">
                                    <button className="grayBTN"
                                    type="button"
                                    onClick={() => this.clearFn()}
                                    >Clear</button>
                                    <button className="orangeBTN"
                                        type="button" 
                                        disabled={this.state.imagePreloader ? true : false}
                                        onClick={(e) => this.submitFn(e)}
                                    >Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                    }

            </React.Fragment>  
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(profilePartnerView)